
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.714 2.286H2.286c-.789 0-1.428.64-1.428 1.428v8.571c0 .79.64 1.429 1.428 1.429h11.428c.79 0 1.429-.64 1.429-1.429v-8.57c0-.79-.64-1.43-1.429-1.43zM.857 6.214h14.285"}})])
          )
        }
      }
    